import React from "react";
import {
    Box,
    Typography,
} from "@mui/material";

import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from "chart.js";

import { Doughnut } from "react-chartjs-2";

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend
);

const COLORS = [
    "#2F64E1", // Academic
    "#7C3AED", // Research
    "#10B981", // Personal
    "#D97706", // Other
];

export default function ProjectSummary({ total, data }) {
    const chartData = {
        labels: data.map((item) => item.name),
        datasets: [
            {
                data: data.map((item) => item.value),
                backgroundColor: COLORS,
                borderWidth: 0,
                cutout: "72%",
                hoverOffset: 4,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
        },
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "100%",
                pr: 3,
                borderRight: "1px solid #E8EDF5",
            }}
        >
            {/* Donut Chart */}
            <Box
                sx={{
                    width: 160,
                    height: 160,
                    position: "relative",
                    flexShrink: 0,
                }}
            >
                <Doughnut
                    data={chartData}
                    options={options}
                />

                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        pointerEvents: "none",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 32,
                            fontWeight: 700,
                            lineHeight: 1,
                            color: "#1E293B",
                        }}
                    >
                        {total}
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: 11,
                            color: "#64748B",
                            mt: 0.5,
                        }}
                    >
                        Projects
                    </Typography>
                </Box>
            </Box>

            {/* Legend */}
            <Box sx={{ ml: 3, flex: 1 }}>
                {data.map((item, index) => (
                    <Box
                        key={item.name}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            mb: 1,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    backgroundColor: COLORS[index],
                                }}
                            />

                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: "#64748B",
                                }}
                            >
                                {item.name}
                            </Typography>
                        </Box>

                        <Typography
                            sx={{
                                fontSize: 12,
                                fontWeight: 600,
                                color: "#1E293B",
                            }}
                        >
                            {item.value}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}